import React from "react";
import { MdStar } from "react-icons/md";
import { useTheme } from "../../../../hooks/useTheme";
import { FullAddress } from "../../../../types/types";
import styles from "./AddressCard.module.scss";

interface AddressCardProps {
  address: FullAddress;
  isSelected: boolean;
  onSelect: (addressId: number) => void;
}

export default function AddressCard({
  address,
  isSelected,
  onSelect,
}: AddressCardProps) {
  const { theme } = useTheme();
  const selectedColor = `${theme.primary}20`;

  // Формирование строки с деталями адреса
  const addressDetails = [
    address.apartment && `кв. ${address.apartment}`,
    address.entrance && `под. ${address.entrance}`,
    address.floor && `эт. ${address.floor}`,
    address.intercom && `домофон ${address.intercom}`,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <button
      className={`${styles.card} ${isSelected ? styles.selected : ""}`}
      onClick={() => onSelect(Number(address.id))}
      style={{
        backgroundColor: isSelected ? selectedColor : "transparent",
        borderColor: isSelected ? theme.primary : theme.border,
      }}
    >
      <div className={styles.header}>
        <h4 className={styles.title} style={{ color: theme.text }}>
          {address.name}
        </h4>

        {address.isGeneral && (
          <div
            className={styles.defaultBadge}
            style={{ backgroundColor: `${theme.success}20` }}
          >
            <MdStar size={12} color={theme.success} />
            <span
              className={styles.defaultBadgeText}
              style={{ color: theme.success }}
            >
              Основной
            </span>
          </div>
        )}
      </div>

      <p className={styles.addressText} style={{ color: theme.text }}>
        {address.address?.value}
      </p>
      <p className={styles.addressText} style={{ color: theme.text }}>
        {address.city?.value}
      </p>

      {/* Детали адреса одной строкой */}
      {addressDetails && (
        <p
          className={styles.addressDetails}
          style={{ color: theme.textSecondary }}
        >
          {addressDetails}
        </p>
      )}

      {address.description && (
        <p className={styles.comment} style={{ color: theme.textSecondary }}>
          Комментарий: {address.description}
        </p>
      )}
    </button>
  );
}
